import { queryOptions, keepPreviousData } from '@tanstack/react-query';
import { receptionApi } from './reception.api';
import type { ShipmentsListParams } from '../types';
import { STALE_TIME } from '@/lib/query/stale-times';

export const receptionKeys = {
  all: ['reception'] as const,
  lists: () => [...receptionKeys.all, 'list'] as const,
  list: (filters: ShipmentsListParams) =>
    [...receptionKeys.lists(), filters] as const,
  details: () => [...receptionKeys.all, 'detail'] as const,
  detail: (id: number) => [...receptionKeys.details(), id] as const,
  metrics: () => [...receptionKeys.all, 'metrics'] as const,
  sessions: () => [...receptionKeys.all, 'session'] as const,
  session: (id: number) => [...receptionKeys.sessions(), id] as const,
  summary: (sessionId: number) =>
    [...receptionKeys.sessions(), sessionId, 'summary'] as const
};

export const receptionQueries = {
  list: (filters: ShipmentsListParams = {}) =>
    queryOptions({
      queryKey: receptionKeys.list(filters),
      queryFn: () => receptionApi.getShipments(filters),
      placeholderData: keepPreviousData
    }),

  detail: (id: number) =>
    queryOptions({
      queryKey: receptionKeys.detail(id),
      queryFn: () => receptionApi.getShipment(id),
      enabled: id > 0
    }),

  metrics: () =>
    queryOptions({
      queryKey: receptionKeys.metrics(),
      queryFn: () => receptionApi.metrics(),
      staleTime: STALE_TIME.metrics
    }),

  summary: (sessionId: number) =>
    queryOptions({
      queryKey: receptionKeys.summary(sessionId),
      queryFn: () => receptionApi.getSummary(sessionId),
      enabled: sessionId > 0
    })
};
